import { useState } from 'react';
import { useToastContext } from '@/contexts/toastContext';
import useApiSubmit from '@/hooks/useApiSubmit';
import interviewsService, { SendPublicInterview } from '@/services/interviews';
import SubmitTechincalChallengeModalComponent, {
  FormData as Data,
  Props as ComponentProps,
} from './SubmitTechnicalChallengeModal.component';

type Props = Omit<ComponentProps, 'onSubmit' | 'isLoading'> & {
  interviewId: string;
  technicalChallengeId: string;
  onSuccess: () => void;
};

const SubmitTechnicalChallengeModal = ({
  technicalChallengeId,
  interviewId,
  onClose,
  onSuccess,
  ...componentProps
}: Props): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const toast = useToastContext();

  const interviewMutation = useApiSubmit<void, SendPublicInterview>(
    interviewsService.sendCandidatePublicTechnicalInterview
  );

  const handleSubmit = async (data: Data): Promise<void> => {
    setIsLoading(true);

    try {
      const payload = new FormData();

      payload.append('technicalChallengeId', technicalChallengeId);
      payload.append('technicalDocumentTitle', data.title);
      payload.append('technicalDocumentContent', data.technicalDesign);
      payload.append('technicalVideo', data.videoPresentation);
      payload.append('githubProjectUrl', data.githubLink);

      await interviewMutation.mutateAsync({
        payload,
        interviewId,
        interviewTechnicalChallengeId: technicalChallengeId,
      });

      toast.showSuccessFeedback('Your project have been submited.');
      onSuccess();
      onClose();
    } catch {
      toast.showErrorFeedback('There was a problem to submit your project, try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SubmitTechincalChallengeModalComponent
      onClose={onClose}
      onSubmit={handleSubmit}
      isLoading={isLoading}
      {...componentProps}
    />
  );
};

export default SubmitTechnicalChallengeModal;
